<script setup lang="ts">
import { storeToRefs } from "pinia";
import LoadingOverlay from "@/shared/components/LoadingOverlay/LoadingOverlay.vue";
import ImpersonationInfoContainer from "@/shared/containers/ImpersonationInfoContainer/ImpersonationInfoContainer.vue";
import { useAppStateStore } from "@/shared/stores/AppStateStore";

const appStateStore = useAppStateStore();
const { isLoading, loadingText } = storeToRefs(appStateStore);
</script>

<template>
  <LoadingOverlay
    v-if="isLoading"
    :text="loadingText"
  />
  <ImpersonationInfoContainer />
  <!-- The key ensures the RouterView re-renders when webStoreId changes (allows for correct data fetching) -->
  <RouterView :key="$route.params.webStoreId as string" />
</template>
